<!-- 创建时间2024/02/21 14:24:32 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：上传须知 -->
<template>
  <div class="yxtbiz-kng-operator__upload-tips" v-if="module === 'kng'">
    <div class="yxtbiz-flex">
      <div class="yxtbiz-flex-1">
        <div class="yxt-weight-6 standard-size-14 color-gray-9 mb8">{{ $t('pc_kng_upload_tit_upload_info'/**上传须知： */) }}</div>
        <div class="standard-size-12 color-gray-7  lh28" v-html="$t('pc_biz_lbl_uploadnotice')"></div>
        <div class="yxtbiz-flex mt20">
          <div class="yxtbiz-flex-1">
            <div class="yxt-weight-6 standard-size-14 color-gray-9 mb8">{{ $t('pc_kng_upload_tit_support_format'/**支持的格式大小： */) }}</div>
            <div class="standard-size-12 color-gray-7 lh28" v-html="uploadLimitTip"></div>
          </div>
        </div>
      </div>
      <div class="yxtbiz-flex-1 ml16" v-if="showMiLiDownload">
        <div class="yxt-weight-6 standard-size-14 color-gray-9 mb8">{{ $t('pc_kng_upload_mili_title'/** 米粒客户端： */) }}</div>    
        <div class="mt12 yxtbiz-flex-center color-gray-7 standard-size-12">
          <yxt-svg :remote-url="`${$staticBaseUrl}ufd/407a24/kng/pc/svg`" width="108px" height="49px" :icon-class="miLiIcon" />
          <div  class="ml12">
            <div>{{ $t('pc_kng_upload_mili_tip3'/** 米粒客户端支持大型文件上传、断点续传、多文件并行上传 */) }}</div>
            <div>
              <span>{{ $t('pc_kng_upload_mili_tip4'/** 若未安装客户端 */) }}</span>
              <yxt-button type="text" class="ml8 standard-size-12" @click="downloadMiLi">{{ $t('pc_kng_mgmt_btn_mili_down'/** 点我下载 */) }}</yxt-button>
            </div>
          </div>
        </div>
        <yxt-button class="mt24" @click="openMili">{{ $t('pc_kng_mgmt_btn_miliplus_start'/** 客户端上传 */) }}</yxt-button>
        <yxtbiz-open-download-tool module="kng" ref="downloadTool"/>
      </div>
    </div>
  </div>
  <div v-else
    class="color-gray-7 mt45 border-dashed border-primary-3 p24">
    <div>{{ $t('pc_kng_upload_tit_upload_info'/**上传须知： */) }}</div>
    <div v-html="$t('pc_biz_lbl_uploadnotice')"></div>
    <div class="mt20">{{ $t('pc_kng_upload_tit_support_format'/**支持的格式大小： */) }}</div>
    <div v-html="uploadLimitTip"></div>
  </div>
</template>

<script>
import { KNG_FILE_TYPE } from 'yxt-biz-pc/packages/select-kng/src/const';
import { handleUploadFileSize } from '../../utils';
import commonUtil from 'yxt-biz-pc/packages/common-util';
export default {
  name: 'kng-upload-tips',
  inject: ['getUploadLimitConfig', 'getUploadConfig'],
  props: {
    module: {
      type: String,
      default: 'ulcd'
    },
    enableUploadZip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    uploadLimitConfig() {
      return this.getUploadLimitConfig();
    },
    uploadLimitTip() {
      return this.$t(this.enableUploadZip && this.module !== 'ulcd' ? 'pc_biz_lbl_sizelimit2' : 'pc_biz_lbl_sizelimit', [
        handleUploadFileSize(this.uploadLimitConfig[KNG_FILE_TYPE.WORD])[0],
        handleUploadFileSize(this.uploadLimitConfig[KNG_FILE_TYPE.IMAGE])[0],
        handleUploadFileSize(this.uploadLimitConfig[KNG_FILE_TYPE.VIDEO])[0],
        handleUploadFileSize(this.uploadLimitConfig[KNG_FILE_TYPE.AUDIO])[0],
        handleUploadFileSize(this.uploadLimitConfig[KNG_FILE_TYPE.ZIP])[0]
      ]);
    },
    showMiLiDownload() {
      const isv = [100, 104, 106].includes(~~localStorage.getItem('sourceCode'));
      const isPublic = this.getUploadConfig().privateEnv !== 1;
      const isShowMiLi = commonUtil.checkTimeOutFnc('download_mili') === 2;
      return !isv && isPublic && isShowMiLi;
    },
    miLiIcon() {
      const lang = commonUtil.getLanguage();
      return ['zh', 'ha'].includes(lang) ? 'mili' : 'mili_en';
    }
  },
  methods: {
    downloadMiLi() {
      this.$refs.downloadTool.handleDownload();
    },
    openMili() {
      this.$refs.downloadTool.open();
    }
  }
};
</script>